import {WEBHOOK_HEADERS, WEBHOOK_HEADER_NAME, WEBHOOK_HEADER_VALUE} from 'views/ScanSettings/NewScan/constants';

export const getCleanArray = (arr) => {
    return arr.filter(function (el) {
        return el != null;
    });
}

export const formatWebhookHeaders = (webhook) => {
    let headers = {};
    if(webhook[WEBHOOK_HEADER_NAME] && webhook[WEBHOOK_HEADER_VALUE]){
        let names = getCleanArray(webhook[WEBHOOK_HEADER_NAME]);
        let values = getCleanArray(webhook[WEBHOOK_HEADER_VALUE]);
        for(let i = 0; i < names.length; i++){
            headers[names[i]] = values[i];
        }
    }
    
    if(!webhook[WEBHOOK_HEADERS]){
        webhook[WEBHOOK_HEADERS] = headers;
        delete webhook[WEBHOOK_HEADER_NAME];
        delete webhook[WEBHOOK_HEADER_VALUE];
    }
    return webhook
}

export const formatWebhooksHeaders = (webhooks) => {
    let formatedWebhooks = [];
    webhooks.forEach((wh) => {
        let formatedWh = formatWebhookHeaders(wh);
        formatedWebhooks.push(formatedWh);
    });
    return formatedWebhooks;
}